/**************************************************
 * Nombre:       Footer
 * Descripcion:
 *
 * Libreria:
 *
 * Tiempo:     5 Hr
 **************************************************/
import {Grid, Typography} from "@mui/material";
import logo from './../Recursos/logo_blanco.svg'

const Footer = () => {

    return (
        <Grid
            container
            justifyContent={'flex-start'}
            alignItems={'flex-start'}
            size={{xs: 12, sm: 12, md: 12}}
            sx={{
                backgroundColor: '#250E4A',
                py: 4,
                px: 3
            }}
        >

            <Grid container size={{xs: 12, sm: 12, md: 12}} sx={{justifyContent: 'center'}}>
                <img src={logo} width={200} height={'auto'}/>
            </Grid>

            <Grid container size={{xs: 12, sm: 12, md: 12}} sx={{justifyContent: 'center', mt: 1}}>
                <Typography sx={{color: '#8E7DB8', fontSize: 14, textAlign: 'center'}}>
                    Copyright © 2026-2027 · Todos los derechos reservados
                </Typography>
            </Grid>

        </Grid>
    )

}
export default Footer    